module.exports = __webpack_public_path__ + "static/media/logo-gold-white.52abce2c.png";